import React from 'react';
import { ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { alreadyGo } from '../data/content';
import { CtaButton } from './CtaButton';
import { LeafSprig } from './decor/LeafSprig';
const mechanism = ['Print.', 'Cut.', 'Share.', 'Plant the seed.'];
export function FinalClose() {
  return <section aria-labelledby="close-title" className="bg-paper" data-id="element-71" data-mp="i5heagxbm69c">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-72" data-mp="i7c1y2zz8ch4">
        <div className="grid gap-14 lg:grid-cols-[1fr_460px] lg:items-center lg:gap-16" data-id="element-73" data-mp="1fs6m57epfd34">
          <div data-id="element-74" data-mp="1au57cyob9zxg">
            <h2 id="close-title" className="text-balance font-display text-[40px] leading-[1.04] text-navy sm:text-[54px]" data-id="element-75" data-mp="1auevshtpjz11">
              How Many Seeds Will You Plant This Week?
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-76" data-mp="113k0knyhhp3g">
              Another week can pass exactly like the last one. <strong className="text-navy" data-id="element-77" data-mp="1yl2bhp9v7sy5">Or this can be the week you start.</strong>
            </p>
            <ul className="mt-6 grid gap-2 text-lg text-ink-soft sm:grid-cols-2" data-id="element-78" data-mp="npc7lryc9igy">
              {alreadyGo.map(a => <li key={a} data-id="element-79" data-mp="sox5dz1rvks3">{a}</li>)}
            </ul>
            <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-80" data-mp="sq8bi5iox4md">
              The opportunities are already around you. Now you can have 200+ Bible verses across 20+ different Gospel-sharing designs ready for
              those opportunities.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-81" data-mp="4x9n25ikti1f">
              You don’t need to wait until you feel fearless. You don’t need to wait until you know everything.{' '}
              <strong className="text-navy" data-id="element-82" data-mp="3r7cjhi70m7zu">You just need to be willing to take the first step.</strong>
            </p>
            <ol className="mt-8 flex flex-wrap gap-x-4 gap-y-1" data-id="element-83" data-mp="1j0yb5qiv">
              {mechanism.map((m, i) => <li key={m} className={`font-display text-3xl sm:text-4xl ${i === mechanism.length - 1 ? 'italic text-leaf-deep' : 'text-navy'}`} data-id="element-84" data-mp="1pclddo84dwxx" data-mpi={i}>
                  {m}
                </li>)}
            </ol>
          </div>

          <div className="relative rounded-3xl bg-cream p-8 text-center shadow-sheet ring-2 ring-coral/25 sm:p-10" data-id="element-85" data-mp="1nwzgk5dl0ljo">
            <LeafSprig className="absolute -right-3 -top-8 h-20 w-10 rotate-12 text-leaf/60" data-id="element-86" data-mp="1ixmlixck4860" />
            <p className="font-display text-2xl leading-tight text-navy sm:text-[28px]" data-id="element-87" data-mp="1e04kru8p0z93">Get the Gospel Sharing Mega Bundle</p>
            <p className="mt-2 font-display text-[88px] leading-none text-coral" aria-label="$24.90" data-id="element-88" data-mp="2bmk0aqhk7mu0">
              $24<span className="align-top text-[44px] leading-none" data-id="element-89" data-mp="26oifa00kpdfw">.90</span>
            </p>
            <p className="mt-4 text-sm font-semibold leading-relaxed text-ink-soft" data-id="element-90" data-mp="21vpd9jwhoj7i">
              200+ Bible Verses · 20+ Printable Designs · 5 Bonuses · Instant Digital Access · 7-Day Guarantee
            </p>
            <CtaButton checkout block className="mt-7" data-id="element-91" data-mp="2uew29c4awm3m">
              Get Instant Access Now
            </CtaButton>
            <div className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-semibold text-ink-soft" data-id="element-92" data-mp="2pl1kwfc64j7p">
              <span className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="31wkh3fqht1ut">
                <ZapIcon className="h-4 w-4 text-gold-deep" aria-hidden="true" data-id="element-94" data-mp="31yx6gdykyehw" />
                Instant Digital Access
              </span>
              <span className="inline-flex items-center gap-1.5" data-id="element-95" data-mp="3bvjqj0j311iv">
                <ShieldCheckIcon className="h-4 w-4 text-leaf-deep" aria-hidden="true" data-id="element-96" data-mp="3guctw04nnc5b" />
                7-Day Guarantee
              </span>
            </div>
          </div>
        </div>
        <p className="mx-auto mt-16 max-w-2xl text-center font-display text-2xl italic leading-snug text-navy sm:text-3xl" data-id="element-97" data-mp="3ktvh52jy7zbb">
          Because someone you cross paths with this week may need the message you’re carrying.
        </p>
      </div>
    </section>;
}